const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
const PHONE_PATTERN = /^[+()\-.\s\d]{7,20}$/;

export type ValidationErrors<T> = Partial<Record<keyof T, string>>;

export function isEmail(value: string): boolean {
  return EMAIL_PATTERN.test(value.trim());
}

export function isPhone(value: string): boolean {
  return PHONE_PATTERN.test(value.trim());
}

export function isBlank(value: string | undefined): boolean {
  return !value || value.trim().length === 0;
}

/** Shared rules so every form reports the same wording for the same mistake. */
export const messages = {
  required: 'This field is required.',
  email: 'Enter a valid email address.',
  phone: 'Enter a valid phone number.',
  tooShort: (min: number) => `Please write at least ${min} characters.`,
} as const;

export function hasErrors<T>(errors: ValidationErrors<T>): boolean {
  return Object.values(errors).some(Boolean);
}
